import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { Typography, Box, MenuItem, ListItemText } from "@mui/material";
import { StyledCheckbox } from "../checkbox/StyledCheckbox.js";
import { MemoizedChip } from "../chip/ChipRenderer.js";
import { ChipVariant, ChipType } from "../chip/types.js";
import { Chip } from "../chip/Chips.js";
import "../chip/ListWithChipTooltip.js";
import "../chip/SquaredChipList.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { useGeneralSelectClasses } from "./selectStyle.js";
const localized = defineMessages({
  group: {
    id: "MultiSelectItemWithSublist_group",
    defaultMessage: "Group"
  }
});
const MultiSelectItem = React.forwardRef(
  ({
    chipValue,
    label,
    isSelected,
    chipType,
    ChipComponent,
    checkbox = true,
    suboption,
    hasSuboptions,
    divider,
    isExpanded,
    onExpand,
    onCollapse,
    ...rest
  }, ref) => {
    const { classes: generalSelectClasses, cx } = useGeneralSelectClasses();
    const { formatMessage } = useIntl();
    function handleTextClick(event) {
      if (hasSuboptions) {
        event.stopPropagation();
        if (isExpanded) {
          onCollapse();
        } else {
          onExpand();
        }
      }
    }
    const checkboxComponent = checkbox ? /* @__PURE__ */ React.createElement(StyledCheckbox, { checked: isSelected, "data-testid": "checkbox" }) : null;
    const primaryComponent = chipType ? /* @__PURE__ */ React.createElement(MemoizedChip, { chipName: chipType, value: Array.isArray(chipValue) ? chipValue[0] : chipValue, cursorPointer: true }) : ChipComponent ? /* @__PURE__ */ React.createElement(ChipComponent, { value: chipValue }) : /* @__PURE__ */ React.createElement(Typography, { variant: "button", className: generalSelectClasses.listItemTextTypography }, /* @__PURE__ */ React.createElement(LocalizedText, { label }));
    const subOptionsExistsMarker = hasSuboptions ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Box,
      {
        className: cx(isExpanded ? CustomIcon.ArrowUp : CustomIcon.ArrowDown, generalSelectClasses.expander),
        component: "span"
      }
    ), /* @__PURE__ */ React.createElement(
      Chip,
      {
        fillWidth: false,
        chipType: ChipType.Prefix,
        label: formatMessage(localized.group),
        chipVariant: ChipVariant.Grey,
        className: generalSelectClasses.chip
      }
    )) : null;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        className: cx(
          generalSelectClasses.menuItem,
          suboption && generalSelectClasses.suboption,
          divider && generalSelectClasses.menuItemDivider,
          !checkbox && generalSelectClasses.cursor
        ),
        "data-testid": `${chipValue}_menuItem`,
        ref,
        ...rest
      },
      checkboxComponent,
      /* @__PURE__ */ React.createElement("div", { onClick: handleTextClick, className: generalSelectClasses.menuSelectItemContent }, /* @__PURE__ */ React.createElement(
        ListItemText,
        {
          className: cx(generalSelectClasses.listItemText, hasSuboptions && generalSelectClasses.groupListItemText),
          disableTypography: true,
          primary: primaryComponent
        }
      ), subOptionsExistsMarker)
    ));
  }
);
export {
  MultiSelectItem
};
//# sourceMappingURL=MultiSelectItem.js.map
